import styled from 'styled-components';

import { colors } from 'styles';

import Tooltip from '../Tooltip';

export const Error = styled(Tooltip)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2rem;
  position: absolute;
  right: 0.5rem;
  z-index: 0;

  svg {
    margin: 0;
    color: ${colors.red_error};
    width: 1.4rem;
    height: 1.4rem;
  }

  span {
    background: ${colors.red_error};
    color: ${colors.text_white};
    font-size: 0.6rem;

    &::before {
      border-color: ${colors.red_error} transparent;
    }
  }
`;
